<template>
    <Link
        :href="
            route('frontend.resources.article', {
                resource_blog_post_slug: post.slug,
            })
        "
        class=""
    >
        <div class="flex justify-between">
            <resource-post-tag :post-type="post.type" />
            <div class="whitespace-nowrap text-gray-600 lg:hidden">
                {{
                    dayjs(post.updated_at)
                        .utc(true)
                        .tz($page.props.display_timezone)
                        .format($page.props.date_formats.short_nice)
                }}
            </div>
        </div>

        <div class="flex justify-between">
            <div class="font-semibold">
                {{ post.title }}
            </div>
            <div class="hidden whitespace-nowrap text-gray-600 lg:block">
                {{
                    dayjs(post.updated_at)
                        .utc(true)
                        .tz($page.props.display_timezone)
                        .format($page.props.date_formats.short_nice)
                }}
            </div>
        </div>
        <div class="text-gray-700">
            {{ post.excerpt }}
        </div>
    </Link>
</template>
<script>
import ResourcePostTag from "@/Components/ResourcePostTag";

export default {
    name: "resource-post-excerpt-link",
    components: { ResourcePostTag },
    props: {
        post: {},
    },
};
</script>
